var customFunctions = function (helpers) {

  var initSliders = function () {
    var sliders = document.querySelectorAll('.lp-slider');

    if (sliders.length === 0) return;

    Array.prototype.forEach.call(sliders, function (slider) {
      var type = slider.dataset.type;

      switch (type) {
        case 'single':
          var swiperSingle = new Swiper('.lp-slider[data-type="single"] .swiper', {
            direction: 'horizontal',
            loop: true,
            lazy: {
              loadPrevNext: true,
            },
            navigation: {
              nextEl: '.next-slide',
              prevEl: '.prev-slide',
            },
            keyboard: {
              enabled: true
            }
          });
        case 'content':
          var swiperContent = new Swiper('.lp-slider[data-type="content"] .swiper', {
            direction: 'horizontal',
            loop: true,
            lazy: {
              loadPrevNext: true,
            },
            navigation: {
              nextEl: '.next-slide',
              prevEl: '.prev-slide',
            },
            keyboard: {
              enabled: true
            }
          });
        case 'multiview':
          var swiperMultiview = new Swiper('.lp-slider[data-type="multiview"] .swiper', {
            slidesPerView: 1,
            loop: false,
            lazy: {
              loadPrevNext: true,
            },
            navigation: {
              nextEl: '.next-slide',
              prevEl: '.prev-slide',
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true
            },
            keyboard: {
              enabled: true
            },
            breakpoints: {
              640: {
                slidesPerView: 3,
                spaceBetween: 20
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 25
              },
              1200: {
                slidesPerView: 4.5,
                spaceBetween: 35
              }
            }
          });

        default:
          break;
      }
    })
  }

  var scrollDown = function () {
    var scrollEl = document.querySelector('.lp-scroll-down a');
    if (!scrollEl) return;

    var scrollToEl = document.getElementById("section-scroll");
    if (!scrollToEl) return;

    scrollEl.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToEl.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start"
      });
    })
  }

  return {
    init: function () {
      initSliders();
      scrollDown();
    },
    resize: function () {
    }
  }
};

document.addEventListener('DOMContentLoaded', function () {
  customFunctions().init();
});